module.exports = __webpack_public_path__ + "static/media/ICON_ADVISOR_ACTIVE.f5184eb1.svg";